import {RootStore} from './RootStore';
import {action} from 'mobx';
import agent from '../api/agent';
import { NotEnrolledParam } from "../models/NotEnrolled";

class NotEnrolledStore{
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore; 
    }

    @action getNotEnrolledList = async (param:NotEnrolledParam) => {
        try 
        {   
            const list = await agent.NotEnrolled.StudentNotEnrolledList(param); 
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action processUpdateCallStatus = async (param:any) => {
        try 
        {   
            const list = await agent.NotEnrolled.processUpdateCallStatus(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getCallReason= async () => {
        const list = this.getResponseCallReason();
        return list;
    };

    getResponseCallReason  = async ()  => {
        const list = await agent.NotEnrolled.callReason();
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };
}

export default NotEnrolledStore;